import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */

export const constantRoutes = [
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () => import("@/views/redirect/index"),
      },
    ],
  },
  {
    path: "/",
    component: Layout,
    redirect: "/giftcard",
    children: [
      {
        path: "giftcard",
        component: () => import("@/views/egiftcard/index"),
        name: "eGift Card",
        meta: { title: "eGift Card" },
      },
    ],
  },
  {
    path: "/",
    component: Layout,
    redirect: "/checkout",
    children: [
      {
        path: "checkout",
        component: () => import("@/views/cart/index"),
        name: "Shopping Cart",
        meta: { title: "Shopping Cart" },
      },
    ],
  },
  {
    path: "/",
    component: Layout,
    redirect: "/payment",
    children: [
      {
        path: "payment",
        component: () => import("@/views/payment/index"),
        name: "Payment",
        meta: { title: "Payment" },
      },
    ],
  },
  {
    path: "/",
    component: Layout,
    redirect: "/signin",
    children: [
      {
        path: "signin",
        component: () => import("@/views/signin/index"),
        name: "SignIn",
        meta: { title: "Please Sign In", hideNavAction: true },
      },
    ],
  },
  {
    path: "/",
    component: Layout,
    redirect: "/gift",
    children: [
      {
        path: "gift",
        component: () => import("@/views/gift/index"),
        name: "gift",
        meta: { title: "gift" },
      },
    ],
  },
  {
    path: "/giftcard/:code",
    component: () => import("@/views/giftcardlist/index"),
  },
];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [];

const createRouter = () =>
  new Router({
    mode: "history", // require service support
    scrollBehavior: () => ({
      y: 0,
    }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
